const PREFIX = 'MODALS_';

export const OPEN = `${PREFIX}OPEN`;
export const CLOSE = `${PREFIX}CLOSE`;
